import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="logo">
              <span className="logo-icon">🎮</span>
              <span className="logo-text">مصاقيل</span>
            </div>
            <p>نبني ألعاباً اجتماعية تجمع الناس والعلامات التجارية</p>
          </div>
          <div className="footer-links">
            <h4>روابط سريعة</h4>
            <ul>
              <li><a onClick={() => scrollToSection('hero')}>الرئيسية</a></li>
              <li><a onClick={() => scrollToSection('demo')}>جرب اللعبة</a></li>
              <li><a onClick={() => scrollToSection('features')}>مميزاتنا</a></li>
              <li><a onClick={() => scrollToSection('partners')}>الشراكات</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 مصاقيل. جميع الحقوق محفوظة.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
